// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"39478c93","368":"bf2f9c90","372":"b1c7dad5","452":"afbe3a29","505":"f9942955","529":"48db45de","598":"adcdf91c","655":"148745d8","711":"42901c56","715":"96a387fd","717":"d1da46e4","828":"bc879422","871":"2614a37c","942":"5bc0dd82","983":"58d41892"}[chunkId] + ".chunk.js";
};